// extracted by mini-css-extract-plugin
module.exports = {"container":"AppLoadingIndicator_container__38xmq"};